import React, { Fragment, useMemo, useState } from "react";

import { ThemeProvider } from "emotion-theming";

import { ApolloProvider } from "react-apollo";
import { ApolloProvider as ApolloHooksProvider } from "react-apollo-hooks";

import { AuthenticationProvider } from "src/banking/AuthenticationContext";
import { createClient } from "src/graphql";
import { theme } from "src/styles";
import { setToken } from "src/sdk";

const ConnectedWrapper = ({ children, history }) => {
  const [authenticationError, setAuthenticationError] = useState(null);

  const client = useMemo(
    () =>
      createClient({ authenticationError, setAuthenticationError, setToken }),
    [authenticationError, setAuthenticationError]
  );

  return (
    <AuthenticationProvider
      currentError={authenticationError}
      setAuthenticationError={setAuthenticationError}
      history={history}
    >
      <ApolloProvider client={client}>
        <ApolloHooksProvider client={client}>
          <ThemeProvider theme={theme}>
            <Fragment>{children}</Fragment>
          </ThemeProvider>
        </ApolloHooksProvider>
      </ApolloProvider>
    </AuthenticationProvider>
  );
};

export default ConnectedWrapper;



// WEBPACK FOOTER //
// ./gatsby-utils/ConnectedWrapper.js